import * as React from 'react';
import moment from 'moment';
import useAuth from '../../hooks/useAuth';
import { useEffect, useState } from 'react';

type GlobalDashBoardProps = {
  heading?: React.ReactNode;
  disableText?: boolean;
};

const GlobalDashboard: React.FunctionComponent<GlobalDashBoardProps> = ({ heading, disableText }): JSX.Element => {
  const { logout, user } = useAuth();
  const username = user?.email_address || user?.first_name || user?.display_name || 'User';
  const todayDate = moment().format('MMM Do YYYY');
  const [currentTime, setCurrentTime] = useState(moment().format('hh:mm A'));

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment().format('hh:mm A'));
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-gray-background-light gray-border-line h-20 border-b px-2">
      <div className="gray-background-light flex h-full items-center justify-between px-4 py-2">
        <div className={disableText ? 'w-1/2' : 'blue-primary flex text-xl font-bold'}>{heading}</div>
        <div className="text-gray-dark flex items-center justify-between text-sm font-medium">
          <div className="min-w-44 px-3 text-right">
            {todayDate} {currentTime}
          </div>
          <div className="px-3 font-bold"> {username}</div>
          <button className="rounded-full bg-white px-5 py-1 text-xs" onClick={() => logout()}>
            LOG OUT
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalDashboard;
